function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import UxModal from './modal.js';
import Confirm from './confirm';
export default UxModal;
var types = [{
  type: 'success',
  iconType: 'ok_circle',
  okCancel: false
}, {
  type: 'info',
  iconType: 'info_circle',
  okCancel: false
}, {
  type: 'error',
  iconType: 'close_circle',
  okCancel: false
}, {
  type: 'warning',
  iconType: 'exclamation_circle',
  okCancel: false
}, {
  type: 'warn',
  iconType: 'exclamation_circle',
  okCancel: false
}, {
  type: 'confirm',
  okCancel: true
}];
types.forEach(function (v) {
  UxModal[v.type] = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      title: '',
      content: ''
    };
    return Confirm(_objectSpread({}, v, {}, props));
  };
});

UxModal.config = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  Confirm.config(props);
};

UxModal.destroy = function () {
  Confirm.destroy();
};